import { ITaskCreatePayload } from "@/src/api/tasksPageRequests";
import { IApplyInfoData } from "@/src/types/applicationOnline";
import { ITasksTableRow } from "@/src/types/tasksTable";

export interface TaskCreateFormState {
  whoose: string;
  type: string;
  intake: string;
  admission_semester: string;
  form_of_education: string;
  selected_course: string;
  category: string;
  medium_of_instruction: string;
  duration: string;
  transfer_fee: string;
  priority: string;
  note: string;
  deadline_date: string;
}

interface BuildTaskCreatePayloadParams {
  applicantId: number;
  form: TaskCreateFormState;
  attachedFile?: string | null;
  assigneeId?: number;
  executorId?: number;
  accounting?: unknown;
}

const readAccountingField = (accounting: unknown, ...keys: string[]): string => {
  if (accounting == null || typeof accounting !== "object") return "";
  const record = accounting as Record<string, unknown>;
  for (const key of keys) {
    const value = record[key];
    if (value != null && String(value).trim()) return String(value).trim();
  }
  return "";
};

export const getCurrentUserId = (): number => {
  const raw = localStorage.getItem("userID");
  if (!raw) return 0;
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (typeof parsed === "number" && Number.isFinite(parsed)) return parsed;
    const asNumber = Number(parsed);
    return Number.isFinite(asNumber) ? asNumber : 0;
  } catch {
    const asNumber = Number(raw);
    return Number.isFinite(asNumber) ? asNumber : 0;
  }
};

export const resolveTaskAssigneeIds = (
  applyInfo: IApplyInfoData | ITasksTableRow,
): { assignee_id: number; executor_id: number } => {
  if ("task_id" in applyInfo) {
    return {
      assignee_id: applyInfo.assignee_id ?? 0,
      executor_id: applyInfo.executor_id ?? 0,
    };
  }

  const currentUserId = getCurrentUserId();
  return {
    assignee_id: currentUserId,
    executor_id: currentUserId,
  };
};

export const buildTaskCreatePayload = ({
  applicantId,
  form,
  attachedFile = null,
  assigneeId,
  executorId,
  accounting,
}: BuildTaskCreatePayloadParams): ITaskCreatePayload => ({
  applicant_id: applicantId,
  assignee_id: assigneeId ?? 0,
  executor_id: executorId ?? 0,
  whoose: form.whoose,
  type: form.type,
  intake: form.intake,
  admission_semester: form.admission_semester,
  form_of_education: form.form_of_education,
  selected_course: form.selected_course,
  category: form.category,
  medium_of_instruction: form.medium_of_instruction,
  duration: form.duration,
  transfer_fee: form.transfer_fee,
  priority: form.priority,
  note: form.note,
  deadline_date: form.deadline_date,
  attached_file: attachedFile,
  tuition_fee: readAccountingField(accounting, "tuitionFee", "tuition_fee"),
  medical_insurance: readAccountingField(accounting, "insurance", "medical_insurance", "medicalInsurance"),
  residence_permit: readAccountingField(accounting, "residencePermit", "residence_permit"),
  other_expenses: readAccountingField(accounting, "otherExpenses", "other_expenses"),
  acommodation: readAccountingField(accounting, "hostelAccommodation", "acommodation", "hostel_accommodation"),
  admission_fee: readAccountingField(accounting, "admissionFee", "admission_fee"),
  complete_one_year: readAccountingField(accounting, "completeOneYear", "complete_one_year"),
});
